
const errorPageModuleConstants = Object.freeze({
    rootStateName: "tb-error",
    prevStateLabel: null,
    stateUrl: "tb-error"
});

export default errorPageModuleConstants;



//////////////////
// WEBPACK FOOTER
// ./src/views/error-page/Constants.js
// module id = 0SH+
// module chunks = 1